import api from "./axios";

export const myOrganisation = () =>
    api.get('/api/organizations/me/');

export const inviteUser = (payload) =>
    api.post('/api/organizations/invite/', payload);

export const updateUserRole = (userId, role) =>
    api.patch(`/api/organizations/users/${userId}/`, { role });

export const removeUser = (userId) =>
    api.delete(`/api/organizations/users/${userId}/`);

export const resendInvite = (inviteId) =>
    api.post(`/api/organizations/invites/${inviteId}/resend/`);

export const revokeInvite = (inviteId) =>
    api.delete(`/api/organizations/invites/${inviteId}/`);
